import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { ConfirmModal, ConfirmContent, ConfirmButtons } from '../../styled/confirm-modal'
import { PrimaryButton, SecondaryButton } from '../../styled/button'

const ModalTitle = styled.h3`
  margin: 0 0 15px 0;
  font-weight: 500;
  color: ${({ theme }) => theme.bodyText};
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`

const Label = styled.label`
  margin-bottom: 5px;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.bodyText};
`

const TextInput = styled.input`
  padding: 8px 12px;
  font-size: 1rem;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background: ${({ theme }) => theme.inputBackground || '#fff'};
  color: ${({ theme }) => theme.bodyText};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
`

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`

function NoteModal ({ isOpen, onSave, onCancel, initialValues }) {
  const [text, setText] = useState('')
  const [isBreak, setIsBreak] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setText(initialValues?.text || '')
      setIsBreak(initialValues?.isBreak || false)
    }
  }, [isOpen, initialValues])

  if (!isOpen) return null

  const handleSave = (e) => {
    e.preventDefault()
    onSave({ text, isBreak })
  }

  const handleCancel = (e) => {
    e.preventDefault()
    onCancel()
  }

  return (
    <ConfirmModal>
      <ConfirmContent width='400px' height='auto'>
        <ModalTitle>{initialValues ? 'Edit Note / Break' : 'Add Note / Break'}</ModalTitle>
        <FormGroup>
          <Label htmlFor='note-text'>Text (max 64 characters)</Label>
          <TextInput
            id='note-text'
            type='text'
            maxLength={64}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder='Enter note text...'
            autoFocus
          />
        </FormGroup>
        <CheckboxGroup>
          <Checkbox
            id='note-is-break'
            type='checkbox'
            checked={isBreak}
            onChange={(e) => setIsBreak(e.target.checked)}
          />
          <Label htmlFor='note-is-break'>Set Break</Label>
        </CheckboxGroup>
        <ConfirmButtons>
          <PrimaryButton onClick={handleSave}>Save</PrimaryButton>
          <SecondaryButton onClick={handleCancel}>Cancel</SecondaryButton>
        </ConfirmButtons>
      </ConfirmContent>
    </ConfirmModal>
  )
}

export default NoteModal
